// Map action types
export const SET_MAP_VIEW_MODE = 'SET_MAP_VIEW_MODE'; 